export default "__VITE_ASSET__CBPJHrPG__"